<template>
    <div class="w-100 h-100 d-flex flex-column align-items-center justify-content-around py-4">
        <span class="font-size-150 text-center px-3" :class="darkText">{{
            'Click on the "Start" button below to create a file from scratch.' | trans
        }}</span>

        <ButtonWithLoadingState
            :text="'Start' | trans"
            icon="fa fa-arrow-right lh-inherit"
            :is-state-loading="isSubmitting"
            show-icon-after-text="true"
            class="position-relative btn btn-lg submit-btn font-size-175 vue-no-upload-start-button"
            @click.stop.prevent="noUploaderStart"
        ></ButtonWithLoadingState>
    </div>
</template>

<script>
import TransFilter from '../../../../qaamgo/modules/sat/components/mixins/TransFilter';
import { eventBus } from '../../../../lib/event-bus/event-bus';
import { VUE_NO_UPLOADER_START_CLICK } from '../../event';
import ButtonWithLoadingState from '../../../../qaamgo/modules/sat/components/form/ButtonWithLoadingState';

export default {
    name: 'NoUploadView',
    components: { ButtonWithLoadingState },
    mixins: [TransFilter],
    methods: {
        noUploaderStart() {
            this.isSubmitting = true;
            eventBus.emit(VUE_NO_UPLOADER_START_CLICK);
        },
    },
    computed: {
        darkText() {
            if (window.pageConfig.uploaderTextColor) {
                return window.pageConfig.uploaderTextColor;
            }
        },
    },
    data() {
        return {
            isSubmitting: false,
        };
    },
};
</script>
